import Ajv from 'ajv';
import ajvKeywords from 'ajv-keywords';
import { filterDOMProps } from 'uniforms';
import { parsePhoneNumber } from 'libphonenumber-js';

const ajv = new Ajv({ allErrors: true, useDefaults: true, jsonPointers: true, verbose: true, $data: true });

ajvKeywords(ajv, ['formatMinimum', 'formatMaximum']);

ajv.addKeyword('isNotEmpty', {
  type: 'string',
  validate(schema, data) {
    return typeof data === 'string' && data.trim() !== '' && data !== null;
  },
  errors: false,
});

ajv.addKeyword('isNotNull', {
  type: 'null',
  validate(schema, data) {
    return data !== null;
  },
  errors: false,
});

ajv.addFormat('tel', maybePhoneNumber => {
  try {
    const result = parsePhoneNumber(maybePhoneNumber);
    return result.isValid();
  } catch (err) {
    return false;
  }
});

ajv.addFormat('email', mail => {
  if (mail === '') {
    return true;
  }
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail);
});

filterDOMProps.register('isNotEmpty');
filterDOMProps.register('oneOf');

export default ajv;
